import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetDiet, GetMealPlans, GetMealPlansByUser, addActivityApi,GenerateMealPlan, updateRecipe } from "../../../fakebackend_helper";
import { APIClient } from "../../../api";
import axios from "axios";




const api = new APIClient();
export const GetAllDietPlanServices = createAsyncThunk(
  'dietPlan/fetchRecipe',
  async (_, { rejectWithValue }) => {
    try {
      const response = await GetDiet();
      return response.data;
    } catch (error) {
      // Renvoie l'erreur avec rejectWithValue pour une meilleure gestion
      return rejectWithValue(error.response?.data || 'Erreur lors du chargement des objectifs');
    }
  }
);

export const GenerateMealPlanForUser = createAsyncThunk(
  'mealPlan/generateMealPlanForUser',
  async ({ userId, body }, { rejectWithValue }) => {
    try {
      const response = await GenerateMealPlan(userId, body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erreur lors de la génération du meal plan');
    }
  }
);

  export const GetMealPlanServices = createAsyncThunk(
    'mealPlans',
    async (_, { rejectWithValue }) => {
      try {
        const response = await GetMealPlans();
        return response.data;
      } catch (error) {
        // Renvoie l'erreur avec rejectWithValue pour une meilleure gestion
        return rejectWithValue(error.response?.data || 'Erreur lors du chargement des objectifs');
      }
    }
  );
  export const GetAllDietPlanByUser = createAsyncThunk(
    'dietPlan/fetchPlanOfUser',
    async (userId, { rejectWithValue }) => {  // Passer userId comme argument
      try {
        const response = await GetMealPlansByUser(userId);  // Utiliser userId dans l'appel API
        console.log('PLAN DE LUTILISATEUR', response.data)
        return response;
      } catch (error) {
        // Renvoie l'erreur avec rejectWithValue pour une meilleure gestion
        return rejectWithValue(error.response?.data || 'Erreur lors du chargement du mealPlan de l utilisateur');
      }
    }
  );

  export const updateRecipeServices = createAsyncThunk(
    "recipe/update",
    async ({ updateData, recipeId, userId  }, { rejectWithValue }) => {
      try {
        const response = await updateRecipe(updateData, recipeId, userId);
        return response.data;
      } catch (error) {
        if (error.response?.data?.message) {
          return rejectWithValue(error.response.message);
        }
        return rejectWithValue(error.response?.data || "Erreur lors de la mise à jour");
      }
    }
  );
  
 
  
  export const addActivity = createAsyncThunk(
    "activity/addActivity",
    async ({ userId, activity }, { rejectWithValue }) => {
      try {
        console.log("Appel de addActivity avec userId:", userId, "et activity:", activity);
  
        // URL correspondant exactement à celle du cURL
       const response = await api.create(
  `http://95.111.225.198:8082/usersApi/api/alimentary/mealPlan/generate-meal-plan?userId=${userId}`,
  {
    ...activity
  }
);

        console.log("Réponse du backend:", response.data);
        return response.data; // Retourne les données reçues du backend
      } catch (error) {
        console.error("Erreur lors de l'ajout de l'activité:", error);
        console.error("Réponse du backend:", error.response?.data);
        return rejectWithValue(error.response?.data || "Erreur lors de l'ajout de l'activité");
      }
    }
  );
  // export const GetAllProgresProgramOfUser = createAsyncThunk(
  //   'dietPlan/fetchProgressData', // Nom de l'action
  //   async (dailyMealPlanId, { rejectWithValue }) => {  // dailyMealPlanId passé en argument
  //     const authUser = JSON.parse(sessionStorage.getItem("authUser"));
  //     const token = authUser?.data?.data?.token;
  
  //     if (!token) {
  //       return rejectWithValue('Aucun token trouvé !');
  //     }
  
  //     console.log("Envoi de la requête avec dailyMealPlanId :", dailyMealPlanId);
  
  //     try {
  //       // Envoi de la requête API avec le dailyMealPlanId
  //       const response = await api.get(`/usersApi/api/logs/Meal-Consumption`, {
  //         params: { dailyMealPlanId },  // Assurer que c'est bien une string
  //         headers: {
  //           Accept: "application/hal+json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });
  
  //       return response.data;  // Retourner les données de la réponse
  
  //     } catch (error) {
  //       // Si une erreur survient, renvoyer l'erreur avec rejectWithValue
  //       return rejectWithValue(error.response?.data || 'Erreur lors du chargement des données de progrès');
  //     }
  //   }
  // );

  
  export const GetAllProgresProgramOfUser = createAsyncThunk(
    'dietPlan/fetchProgressData', // Nom de l'action
    async (dailyMealPlanId, { rejectWithValue }) => {
      console.log("GetDailyDataDashUser called with ID:", dailyMealPlanId); // Vérification
  
      try {

        console.log("Params:", { dailyMealPlanId });
        
        const response = await axios.get(
          "http://95.111.225.198:8082/usersApi/api/logs/MealConsumption",
          {
             params: { dailyMealPlanId }
          }
        );
  
        console.log("Réponse API:", response.data);
        return response.data;
      } catch (error) {
        console.error("Erreur API:", error.response?.data || error);
        return rejectWithValue(error.response?.data || "Erreur inconnue");
      }
    }
  );
 
